import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';

@Component({
  selector: 'yt-trosak-dokument-stavka-update-container',
  templateUrl: './trosak-dokument-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class TrosakDokumentStavkaUpdateContainerComponent<T extends BaseEntity> extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}
@ViewChild("baseDetailList", { static: false }) baseDetailList: any;
tempItems: List<T>

setItems(items){
  this.tempItems = items;
}
  ngAfterViewInit() {
    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
    }
  }

}
